module.exports = __webpack_public_path__ + "static/anand-c742d2e37e9186fada66767c1f22d235.png";